/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DeleteFeedAccessTokenRequest} from "../model/delete-feed-access-token-request";
import {SuccessResponse} from "../model/success-response";
import {UserCalendarFeedAccessToken} from "../model/user-calendar-feed-access-token";

@Injectable({
    providedIn: "root",
})
export class SimUserCalendarFeedService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteFeedAccessToken(request: DeleteFeedAccessTokenRequest) {
        return super.post<SuccessResponse>(`/api/UserCalendarFeed/DeleteFeedAccessToken`, request);
    }

    public generateFeedAccessToken() {
        return super.post<UserCalendarFeedAccessToken>(`/api/UserCalendarFeed/GenerateFeedAccessToken`, {});
    }

    public getFeedAccessTokensForCurrentUser() {
        return super.get<UserCalendarFeedAccessToken[]>(`/api/UserCalendarFeed/GetFeedAccessTokensForCurrentUser`, );
    }

    public getUserCalendarFeed_Url(tokenString: string) {
        return super.getUrl(`/api/UserCalendarFeed/GetUserCalendarFeed/${encodeURIComponent(tokenString)}`, );
    }
}